// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publication-editor .ProseMirror {
	min-height: 360px;
	outline: none;
	font-family: inherit;
	font-size: 15px;
	line-height: 1.95;
	color: #1e3a5f;
	caret-color: #ff694b;
}

.publication-editor .ProseMirror p.is-editor-empty:first-child::before {
	color: rgba(30, 58, 95, 0.35);
	content: attr(data-placeholder);
	float: right;
	height: 0;
	pointer-events: none;
}

.publication-editor .ProseMirror h1 {
	font-weight: 800;
	font-size: 1.65rem;
	line-height: 1.35;
	margin: 1.25rem 0 0.75rem;
	color: #16365a;
}

.publication-editor .ProseMirror h2 {
	font-weight: 700;
	font-size: 1.35rem;
	line-height: 1.4;
	margin: 1.1rem 0 0.6rem;
	color: #16365a;
}

.publication-editor .ProseMirror h3 {
	font-weight: 700;
	font-size: 1.15rem;
	line-height: 1.45;
	margin: 1rem 0 0.5rem;
	color: #16365a;
}

.publication-editor .ProseMirror p {
	margin: 0.5rem 0;
}

.publication-editor .ProseMirror ul,
.publication-editor .ProseMirror ol {
	margin: 0.75rem 0;
	padding-right: 1.5rem;
	padding-left: 0;
}

.publication-editor .ProseMirror li {
	margin: 0.25rem 0;
}

.publication-editor .ProseMirror blockquote {
	margin: 1rem 0;
	padding: 0.75rem 1rem;
	border-right: 4px solid rgba(255, 105, 75, 0.65);
	background: rgba(240, 246, 252, 0.9);
	border-radius: 0 12px 12px 0;
	color: rgba(30, 58, 95, 0.85);
}

.publication-editor .ProseMirror pre {
	margin: 1rem 0;
	padding: 1rem;
	border-radius: 12px;
	background: #1e293b;
	color: #f8fafc;
	overflow-x: auto;
	font-size: 13px;
	line-height: 1.6;
}

.publication-editor .ProseMirror code {
	font-size: 0.9em;
	background: rgba(30, 58, 95, 0.08);
	padding: 0.1em 0.35em;
	border-radius: 4px;
}

.publication-editor .ProseMirror pre code {
	background: transparent;
	padding: 0;
}

.publication-editor .ProseMirror mark {
	background: #fef08a;
	border-radius: 2px;
	padding: 0 2px;
}

.publication-editor .ProseMirror a {
	color: #2563eb;
	text-decoration: underline;
	text-underline-offset: 2px;
}

.publication-editor .ProseMirror img {
	max-width: 100%;
	height: auto;
	margin: 1rem auto;
	display: block;
	border-radius: 12px;
	box-shadow: 0 8px 24px rgba(39, 106, 166, 0.12);
}

.publication-editor .ProseMirror hr {
	border: none;
	border-top: 1px solid rgba(30, 58, 95, 0.15);
	margin: 1.5rem 0;
}

.publication-editor .ProseMirror ul[data-type="taskList"] {
	list-style: none;
	padding-right: 0.25rem;
}

.publication-editor .ProseMirror ul[data-type="taskList"] li {
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
}

.publication-editor .ProseMirror ul[data-type="taskList"] li label {
	flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/publication/common/TipTapEditor/tiptapEditor.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,aAAa;CACb,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;CAC7B,+BAA+B;CAC/B,YAAY;CACZ,SAAS;CACT,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,iBAAiB;CACjB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gDAAgD;CAChD,oCAAoC;CACpC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,mBAAmB;CACnB,+CAA+C;AAChD;;AAEA;CACC,YAAY;CACZ,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC,SAAO;AACR","sourcesContent":[".publication-editor .ProseMirror {\n\tmin-height: 360px;\n\toutline: none;\n\tfont-family: inherit;\n\tfont-size: 15px;\n\tline-height: 1.95;\n\tcolor: #1e3a5f;\n\tcaret-color: #ff694b;\n}\n\n.publication-editor .ProseMirror p.is-editor-empty:first-child::before {\n\tcolor: rgba(30, 58, 95, 0.35);\n\tcontent: attr(data-placeholder);\n\tfloat: right;\n\theight: 0;\n\tpointer-events: none;\n}\n\n.publication-editor .ProseMirror h1 {\n\tfont-weight: 800;\n\tfont-size: 1.65rem;\n\tline-height: 1.35;\n\tmargin: 1.25rem 0 0.75rem;\n\tcolor: #16365a;\n}\n\n.publication-editor .ProseMirror h2 {\n\tfont-weight: 700;\n\tfont-size: 1.35rem;\n\tline-height: 1.4;\n\tmargin: 1.1rem 0 0.6rem;\n\tcolor: #16365a;\n}\n\n.publication-editor .ProseMirror h3 {\n\tfont-weight: 700;\n\tfont-size: 1.15rem;\n\tline-height: 1.45;\n\tmargin: 1rem 0 0.5rem;\n\tcolor: #16365a;\n}\n\n.publication-editor .ProseMirror p {\n\tmargin: 0.5rem 0;\n}\n\n.publication-editor .ProseMirror ul,\n.publication-editor .ProseMirror ol {\n\tmargin: 0.75rem 0;\n\tpadding-right: 1.5rem;\n\tpadding-left: 0;\n}\n\n.publication-editor .ProseMirror li {\n\tmargin: 0.25rem 0;\n}\n\n.publication-editor .ProseMirror blockquote {\n\tmargin: 1rem 0;\n\tpadding: 0.75rem 1rem;\n\tborder-right: 4px solid rgba(255, 105, 75, 0.65);\n\tbackground: rgba(240, 246, 252, 0.9);\n\tborder-radius: 0 12px 12px 0;\n\tcolor: rgba(30, 58, 95, 0.85);\n}\n\n.publication-editor .ProseMirror pre {\n\tmargin: 1rem 0;\n\tpadding: 1rem;\n\tborder-radius: 12px;\n\tbackground: #1e293b;\n\tcolor: #f8fafc;\n\toverflow-x: auto;\n\tfont-size: 13px;\n\tline-height: 1.6;\n}\n\n.publication-editor .ProseMirror code {\n\tfont-size: 0.9em;\n\tbackground: rgba(30, 58, 95, 0.08);\n\tpadding: 0.1em 0.35em;\n\tborder-radius: 4px;\n}\n\n.publication-editor .ProseMirror pre code {\n\tbackground: transparent;\n\tpadding: 0;\n}\n\n.publication-editor .ProseMirror mark {\n\tbackground: #fef08a;\n\tborder-radius: 2px;\n\tpadding: 0 2px;\n}\n\n.publication-editor .ProseMirror a {\n\tcolor: #2563eb;\n\ttext-decoration: underline;\n\ttext-underline-offset: 2px;\n}\n\n.publication-editor .ProseMirror img {\n\tmax-width: 100%;\n\theight: auto;\n\tmargin: 1rem auto;\n\tdisplay: block;\n\tborder-radius: 12px;\n\tbox-shadow: 0 8px 24px rgba(39, 106, 166, 0.12);\n}\n\n.publication-editor .ProseMirror hr {\n\tborder: none;\n\tborder-top: 1px solid rgba(30, 58, 95, 0.15);\n\tmargin: 1.5rem 0;\n}\n\n.publication-editor .ProseMirror ul[data-type=\"taskList\"] {\n\tlist-style: none;\n\tpadding-right: 0.25rem;\n}\n\n.publication-editor .ProseMirror ul[data-type=\"taskList\"] li {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 0.5rem;\n}\n\n.publication-editor .ProseMirror ul[data-type=\"taskList\"] li label {\n\tflex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
